import { PublicPolicyPage } from '@/components/PublicPolicyPage';

export default function RefundPage() {
  return (
    <PublicPolicyPage
      title="Refund and Cancellation Policy"
      summary="This draft records the selected launch policy: cancel anytime, keep paid access through the current billing period, and no prorated refunds."
      testId="heading-refund"
      statusLabel="Draft for owner and legal review"
      dateLabel="Draft date: August 27, 2026"
      reviewNotice="This draft is provided for business-owner and legal review. It should be reviewed for the company’s legal name, address, jurisdiction, contact information, service providers, and operating practices before it becomes effective."
    >
      <section>
        <h2 className="mb-3 text-xl font-bold text-white">1. When this policy applies</h2>
        <p>This policy is intended to apply when ADA Widget activates paid subscriptions. Any different trial, promotional, or agency terms should be shown clearly before purchase and added to the effective policy.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">2. Cancel anytime</h2>
        <p>You may cancel a paid subscription at any time. Cancellation prevents the next renewal and takes effect at the end of the current paid billing period. There is no separate cancellation fee.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">3. Access after cancellation</h2>
        <p>After cancellation, paid features remain available through the end of the billing period already purchased. Unless another retention period is required by law or stated in the effective terms, access may be reduced or removed after that period ends.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">4. No prorated refunds</h2>
        <p>ADA Widget does not provide prorated refunds or credits for partial billing periods, unused time, unused features, or a decision to stop using the service before the paid period ends. Payments are otherwise final except where applicable law requires a refund.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">5. Billing errors</h2>
        <p>The effective policy should provide a support method for reporting duplicate charges, incorrect amounts, or other billing errors. ADA Widget will review reported billing errors and issue corrections or refunds when appropriate.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">6. Plan changes</h2>
        <p>Pricing and timing for upgrades or downgrades should be displayed before a customer confirms the change. Downgrades should ordinarily take effect at the next renewal and do not create a prorated refund for the current period unless required by law.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">7. Contact and effective date</h2>
        <p>A branded billing-support email, company identity, effective date, and instructions for cancelling through the account or payment provider must be added before this draft becomes the effective customer policy.</p>
      </section>
    </PublicPolicyPage>
  );
}